import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const ROOT = `${API_BASE_URL}/api/netplus/modem-status`;

// Opening entry payload:  { date, opening: { inactive, suspended, terminated }, note }
// Daily entry payload:    { date, recovered: {...}, recharge: {...}, added: {...}, note }
export const createNetplusModemEntryApi = (payload) => axios.post(ROOT, payload);

export const updateNetplusModemEntryApi = (id, payload) =>
  axios.put(`${ROOT}/${id}`, payload);

export const deleteNetplusModemEntryApi = (id) =>
  axios.delete(`${ROOT}/${id}`);
